import { render, staticRenderFns } from "./CloseAccounts.vue?vue&type=template&id=2d2804fa"
import script from "./CloseAccounts.vue?vue&type=script&lang=js"
export * from "./CloseAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports